import * as types from './ActionTypes';
import {
    getAllRepresentativesCall,
    getCustomerRepresentatives,
    getRepresentative,
    // updateRepresentative
} from '../../api/network/businessCustomerService';
export const REPRESENTATIVE = "[Representative]";
export const FETCH_ALL_REPRESENTATIVES = `${REPRESENTATIVE} FETCH_REPRESENTATIVES`;
export const FETCH_COMPANY_REPRESENTATIVES = `${REPRESENTATIVE} FETCH_COMPANY_REPRESENTATIVES`;
export const FETCH_CUSTOMER_REPRESENTATIVES = `${REPRESENTATIVE} FETCH_CUSTOMER_REPRESENTATIVES`;
export const FETCH_REPRESENTATIVE = `${REPRESENTATIVE} FETCH_REPRESENTATIVE`;
export const UPDATE_REPRESENTATIVE = `${REPRESENTATIVE} UPDATE_REPRESENTATIVE`;
export const REMOVE_REPRESENTATIVE = `${REPRESENTATIVE} REMOVE_REPRESENTATIVE`;
export const ADD_REPRESENTATIVE = `${REPRESENTATIVE} ADD_REPRESENTATIVE`;


export const SET_REPRESENTATIVES = `${REPRESENTATIVE} Set`;
export const PUT_REPRESENTATIVE = `${REPRESENTATIVE} Put`;
export const DELETE_REPRESENTATIVE = `${REPRESENTATIVE} Delete`;
export const INSERT_REPRESENTATIVE = `${REPRESENTATIVE} Insert`;


export const fetchRepresentativesSuccess = representatives => ({
    type: types.GET_REPRESENTATIVES_SUCCESS,
    payload: representatives
});
export const fetchCustomerRepresentativesSuccess = representatives => ({
    type: types.GET_CUSTOMER_REPRESENTATIVES_SUCCESS,
    payload: representatives
});
export const fetchRepresentativeSuccess = representative => ({
    type: types.GET_REPRESENTATIVE_SUCCESS,
    payload: representative
});
export const updateRepresentativeSuccess = representative => ({
    type: types.UPDATE_REPRESENTATIVE_SUCCESS,
    payload: representative
});

export const fetchRepresentative = (companyId, customerId, repId) => dispatch => {
    getRepresentative(companyId, customerId, repId)
        .then(data => dispatch(fetchRepresentativeSuccess(data)))
        .catch(error => console.error('Failed to get representative', error));
};

export const fetchRepresentatives = () => dispatch => {
    getAllRepresentativesCall()
        .then(data => dispatch(fetchRepresentativesSuccess(data)))
        .catch(error => console.error('Failed to get representatives', error));
};


export const fetchAllRepresentatives = () => ({
   type: FETCH_ALL_REPRESENTATIVES,
   payload: {}
});

export const fetchCompanyRepresentatives = (companyId) => ({
   type: FETCH_COMPANY_REPRESENTATIVES,
   payload: {
       meta: {
           companyId
       }
   }
});

export const fetchCustomerRepresentatives = (companyId, customerId) => ({
   type: FETCH_CUSTOMER_REPRESENTATIVES,
   payload: {
       meta: {
           companyId,
           customerId
       }
   }
});

export const setRepresentatives = (data) => ({
    type: SET_REPRESENTATIVES,
    payload: {
        data
    }
});

export const saveRepresentative = (companyId, customerId, repId, representativeToUpdate) => ({
   type: UPDATE_REPRESENTATIVE,
   payload: {
       data: representativeToUpdate,
       meta: {
           companyId,
           customerId,
           repId,
       }
   }
});


export const putRepresentative = (data) => ({
   type: PUT_REPRESENTATIVE,
    payload: {
       data
    }
});


